import i18next from 'i18next';


function lineItemHtml(li, props) {
  // Additional properties:
  // li.titleWithQty               - `2 x Widgets` if qty > 2, otherwise "Widgets" if qty = 1.
  // li.imageTag                   - Either an <img> tag or "" if no image or images disabled.
  // li.totalComparePrice          - ComparePrice * Quantity
  // li.totalComparePriceFormatted - totalComparePrice with Intl formatting.
  // li.totalPrice                 - Price * Quantity
  // li.totalPriceFormatted        - totalPrice with Intl formatting.
  if (props.showComparePricing && li.totalComparePrice > 0) {
    return `<tr class="product-line">
          <td>${li.imageTag}${li.titleWithQty}</td>
          <td class="checkout-money">
            <div class="compare-at-price">
              ${li.totalComparePriceFormatted}
            </div>
            ${li.totalPriceFormatted}
          </td>
        </tr>`;
  } else {
    return `<tr class="product-line">
          <td>${li.imageTag}${li.titleWithQty}</td>
          <td class="checkout-money">${li.totalPriceFormatted}</td>
        </tr>`;
  }
}

function lineItemsHtml(props) {

  const fn = props.lineItemHtmlFn ? props.lineItemHtmlFn : lineItemHtml;

  return props.currencyCart.lineItems.map(x => {
    const newLi = Object.assign({}, x);
    newLi.imageTag = "";
    if (props.showProductImages && typeof(newLi.productImage) === 'string' && newLi.productImage.length > 0) {
      newLi.imageTag = `<img src="${newLi.productImage}" alt="${newLi.title}"></img>`;
    }
    newLi.titleWithQty = newLi.title;
    if (newLi.quantity > 1) {
      newLi.titleWithQty = `${newLi.quantity} x ${newLi.titleWithQty}`;
    }
    newLi.totalPrice = newLi.price*newLi.quantity;
    newLi.totalPriceFormatted = props.currencyFormatter(newLi.totalPrice);
    newLi.comparePrice = newLi.comparePrice || 0;
    newLi.totalComparePrice = newLi.compareAtPrice*newLi.quantity;
    newLi.totalComparePriceFormatted = props.currencyFormatter(newLi.totalComparePrice);


    return fn(newLi, props);
  }).join("");
}

function couponRowHtml(props) {
  if (props.currencyCart.discountTotal === 0) {
    return '';
  }
  const negDiscount = props.currencyFormatter(props.currencyCart.discountTotal * -1);
  return `<tr class="discount-line">
            <td>${i18next.t("cart.discountLabel")}</td>
            <td class="checkout-money">${negDiscount}</td>
          </tr>`;
}


function subtotalLine(props) {
  let total = props.currencyFormatter(props.currencyCart.subTotal);
  return `<tr class="subtotal-line">
            <td>${i18next.t("cart.subtotalLabel")}</td>
            <td class="checkout-money">${total}</td>
          </tr>`;

}

function shippingRowHtml(props) {
  const shippingAmount = (!props.currencyCart.shippingTotal || props.currencyCart.shippingTotal < 0.01) ? i18next.t("cart.freeShipping") : props.currencyFormatter(props.currencyCart.shippingTotal);
  return `<tr class="shipping-line">
            <td>${i18next.t("cart.shippingLabel")}</td>
            <td class="checkout-money">${shippingAmount}</td>
          </tr>`;
}

function taxRowHtml(props) {
  if (!props.currencyCart.state.taxCalculated) {
    return '';
  }

  let total = props.currencyFormatter(props.currencyCart.taxTotal);
  return `<tr class="tax-line">
            <td>${i18next.t("cart.taxLabel")}</td>
            <td class="checkout-money">${total}</td>
          </tr>`;
}

function grandTotalHtml(props) {
  let total = props.currencyFormatter(props.currencyCart.total);

  if (props.showVatIncluded) {
    return `<tr class="total-line">
              <td>${i18next.t("cart.grandTotalLabel")}<div class="taxPendingMessage"><span class="asterisk">*</span>${i18next.t("cart.vatIncluded")}</div></td>
              <td class="checkout-money">${total}<span class="asterisk">*</span></td>
            </tr>`;

  }

  if (props.showTaxPendingMessage && !props.currencyCart.state.taxCalculated) {
    return `<tr class="total-line">
              <td>${i18next.t("cart.grandTotalLabel")}<div class="taxPendingMessage"><span class="asterisk">*</span>${i18next.t("cart.taxPendingMessage")}</div></td>
              <td class="checkout-money">${total}<span class="asterisk">*</span></td>
            </tr>`;

  } else {
    return `<tr class="total-line">
              <td>${i18next.t("cart.grandTotalLabel")}</td>
              <td class="checkout-money">${total}</td>
            </tr>`;
  }

}

export function cartHtml(props) {
  let result = '';
  const lineItems = props.currencyCart.lineItems;
  result += '<table style="width: 100%">';
  result += '<tbody>';
  result += lineItemsHtml(props);
  result += subtotalLine(props);
  result += couponRowHtml(props);
  result += shippingRowHtml(props);
  result += taxRowHtml(props);
  result += grandTotalHtml(props);
  result += '</tbody>';
  result += '</table>';
  return result;
}
